import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import { FunctionComponent } from 'react';
import { useAppTranslate } from '../../../../core/hooks';
import { Loader } from '../../../../ui/components';
import { StatisticsTableChartOptions } from '../../../chart-settings/components';
import { useChartSettings } from '../../../chart-settings/hooks';
import { ChartSettings } from '../../../chart-settings/model';
import { useAvailabilityMeasurementsApiGet, useCpuMeasurementsApiGet } from '../../hooks';
import { MonitoredDeviceModel } from '../../model';
import { useTimeSeriesStatisticsHighchartsOptions } from '../../../timeseries-statistics/hooks/TimeSeriesStatistics.hook';
import { buildSeriesData } from '../../../timeseries-statistics/model/TimeSeriesMeasurement.model';

interface Props {
  initialChartSettings: ChartSettings;
  dataType: 'cpuUsage' | 'availability';
  device: MonitoredDeviceModel;
  open: boolean;
  onClose: () => void;
  customerId: number;
}

export const CpeStatisticsTableChartDialog: FunctionComponent<Props> = (
  { dataType, device, open, onClose, initialChartSettings, customerId },
) => {
  const hookMethod = dataType === 'cpuUsage' ? useCpuMeasurementsApiGet : useAvailabilityMeasurementsApiGet;
  const chartSettingsInteraction = useChartSettings({
    timespan: initialChartSettings.timespan,
    resolution: initialChartSettings.resolution,
  });
  const chartSettings = chartSettingsInteraction.chartSettings;
  const {
    data,
    isFetched,
    isFetching,
  } = hookMethod(customerId, device.deviceId, chartSettings, 'dialog');
  const translate = useAppTranslate();
  const seriesName = `${translate('tableHeaders.' + dataType)}`;
  const seriesData = buildSeriesData(data || []);
  const highchartsOptions = useTimeSeriesStatisticsHighchartsOptions(chartSettings, '%', [{ seriesData, seriesName }]);

  return <>
    <Dialog open={open} onClose={onClose} disableEscapeKeyDown={true} maxWidth={'xl'} fullWidth={true}>
      <Box sx={{ p: { xs: '2rem', sm: '6rem' } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', pb: 2 }}>
          <Box>
            <Typography variant={'h5'}>{device.serviceName} | {translate(`tableHeaders.${dataType}`)}</Typography>
            <Typography variant={'h6'}>{translate(`tableHeaders.sozId`)}: {device.orderNumber} | {device.deviceName}</Typography>
          </Box>
          <Box>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <StatisticsTableChartOptions chartSettingsInteraction={chartSettingsInteraction} />
        <Loader loading={isFetching} />
        { data && isFetched && !isFetching && <HighchartsReact
          highcharts={ Highcharts }
          options={ highchartsOptions }
        /> }
      </Box>
    </Dialog>
  </>;
};